<template>
    <div class="main">
        <header-component v-if="$route.name !== 'documentview'" />
        <router-view />
    </div>
</template>

<script>
    import header from './components/header.vue';
    import '@progress/kendo-theme-default/dist/all.css';
    import './assets/css/kendoTheme.css';

    export default {
        data() {
            return {
                mobileWindow: false
            }
        },
        async mounted() {
            if (!window.location.href.includes('Document?id=') && ((screen.orientation?.type?.toLowerCase().includes('landscape') && window.innerHeight <= 600)
                || (screen.orientation?.type?.toLowerCase().includes('portrait') && window.innerWidth <= 800))) {
                this.mobileWindow = true;
                await this.$store.dispatch('loadIsMobile', this.mobileWindow);
                this.$router.push('/getApp');
            } else {
                this.mobileWindow = false;
                await this.$store.dispatch('loadIsMobile', this.mobileWindow);
            }
        },
        components: {
            'header-component': header
        }
    }
</script>
<style>
    @import '../src/assets/css/site.css';

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100vh;
    }

    nav {
        padding: 30px;
    }

    nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    nav a.router-link-exact-active {
        color: #42b983;
    }
</style>
